'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var modules_6b210db9 = {"container":"Menu_module_container__83f0f3ec","item-base":"Menu_module_itemBase__83f0f3ec","item-group":"Menu_module_itemGroup__83f0f3ec","item":"Menu_module_item__83f0f3ec","active":"Menu_module_active__83f0f3ec","disabled":"Menu_module_disabled__83f0f3ec","icon":"Menu_module_icon__83f0f3ec","control":"Menu_module_control__83f0f3ec","control-indent":"Menu_module_controlIndent__83f0f3ec","description":"Menu_module_description__83f0f3ec","text":"Menu_module_text__83f0f3ec","label":"Menu_module_label__83f0f3ec"};
require("../../../assets/cjs/components/Menu/src/Menu~DXSWE7pY.css");

exports.default = modules_6b210db9;
//# sourceMappingURL=Menu.module.less.js.map
